import { memo } from "react";
import { Div, PageHeader, useMediaQuery, useTheme } from "react-better-html";

type SettingItemProps = React.ComponentProps<typeof PageHeader> & {
   isBox?: boolean;
   breakMobile?: boolean;
};

function SettingItem({ isBox, breakMobile, rightElement, ...props }: SettingItemProps) {
   const theme = useTheme();
   const mediaQuery = useMediaQuery();

   const isMobile = mediaQuery.size600 && breakMobile;

   const component = (
      <Div>
         <PageHeader
            titleAs="h4"
            descriptionFontSize={14}
            rightElement={!isMobile ? rightElement : undefined}
            marginBottom={isMobile ? theme.styles.gap : 0}
            {...props}
         />

         {isMobile ? rightElement : undefined}
      </Div>
   );

   return isBox ? (
      <Div.box
         backgroundColor={theme.colors.backgroundBase}
         border="none"
         paddingInline={theme.styles.space}
         paddingBlock={(theme.styles.space + theme.styles.gap) / 2}
      >
         {component}
      </Div.box>
   ) : (
      component
   );
}

export default memo(SettingItem);
